import styled from 'styled-components';

import ArtifactBaseForm from '@/features/artifacts/components/ArtifactBaseForm';
import { ArtifactFieldLayout } from '@/features/artifacts/components/ArtifactForm/styles';

export const BaseForm = styled(ArtifactBaseForm)`
  ${ArtifactFieldLayout} {
    flex: 1 1 100%;
  }
`;
